import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "da-apy-span" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_da_tooltip = _resolveComponent("da-tooltip")!

  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _createTextVNode(" APY "),
    _createVNode(_component_da_tooltip, {
      class: _normalizeClass(["apy-tooltip-span", _ctx.apyTooltipIconCSSClass]),
      iconVersion: _ctx.iconVersion,
      title: _ctx.apyTitleText
    }, null, 8, ["class", "iconVersion", "title"])
  ]))
}